var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "ItpBox",
        { staticClass: "p-3", attrs: { direction: "column" } },
        [
          _c(
            "ItpBox",
            { staticClass: "mb-3", attrs: { alignItems: "center" } },
            [
              _c("strong", [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("pgettext")("Invoicing configuration", "Settings")
                    ) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c("ItpButton", {
                staticClass: "ml-3",
                attrs: {
                  icon: "fa-sync-alt",
                  text: _vm._f("gettext")("Reload"),
                  variant: "light",
                  size: "sm",
                  spinning: _vm.actions.reload.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_3343864469950044_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.loaded
            ? _c("ItpDataTable", {
                ref: "table",
                staticClass: "h-100",
                attrs: {
                  tableId: "Settings.Invoicing",
                  editable: "",
                  isRowEditable: function(p) {
                    return !p.locked
                  },
                  value: _vm.items,
                  "no-create-row": "",
                  "no-delete-row": "",
                  globs: {
                    configureNumbering: _vm.configureNumbering,
                    configureProvider: _vm.configureProvider,
                    setAsDefaultNumbering: _vm.setAsDefaultNumbering
                  },
                  columns: _vm.b_5962862420439144_columns
                },
                on: {
                  save: function($event) {
                    return _vm.evh_5962862420439144_save($event, {})
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }